var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-box"},[_c('tabs',{staticClass:"my-tabs",attrs:{"animated":"","id":"my-tabs"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.columnList),function(v,i){return _c('tab',{key:i,attrs:{"title":v.label}},[_c(v.path,{tag:"component",attrs:{"activityId":v.id}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }